import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { WizardStep, Checklist, FileDoc, FileUploadService } from 'src/app/core/components';
import { NgForm } from '@angular/forms';
import { Subscription, Subject, forkJoin } from 'rxjs';
// import { TreeviewItem } from 'ngx-treeview';
import { GLOBAL } from 'src/app/app.globals';
import { ContractorsService } from '../contractors.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from 'src/app/core/services';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { LogHelperService } from 'src/app/core/services/log-helper.service';
import { EnumRoleType, Master } from '../../const/enum';
declare let _;
@Component({
  selector: 'app-create-sub-contractor',
  templateUrl: './create-sub-contractor.component.html',
  styleUrls: ['./create-sub-contractor.component.css']
})


export class CreateSubContractorComponent implements OnInit, AfterViewInit, OnDestroy {
  isContractore : any= localStorage.getItem('RoleCode');
  enumRoleType:any=EnumRoleType;
  formChangesSubscription: Subscription;
  @ViewChild('contractorForm') contractorForm: NgForm;
  checkList: Checklist[] = [];
  wizardSteps: WizardStep[] = [];
  contractorTypes: any[] = [];
  entityTypes:any = [];
  contractorCode: number;
  ecPolicies :any= [];
  masterItemList :any = [];
  statusOfIndustries = [];
  addressTypes :any= [];
  contactPerTypes:any = [];
  bankNames:any = [];
  accountTypes :any= [];
  countries:any = [];
  lcountries :any= [];
  states :any= [];
  districts :any= [];
  cities :any= [];
  postOfficies:any = [];
  statesLocal :any= [];
  districtsLocal :any= [];
  citiesLocal :any= [];
  postOfficiesLocal :any= [];
  headerTitleName:string='';

  complienceInfoCode: number;
  // tslint:disable-next-line:variable-name
  ContractorContactPersonViews :any= [];
  hideAddContactPerson = false;
  disableAddContactPerson = true;
  hideUpdateContactPerson = true;
  editContractorContactPersonIndex: number;

  drivingLicenceTypes :any= [];
  contractorContactStates:any = [];
  hideAddContactState:any = false;
  disableAddContactState :any= true;
  hideUpdateContactState :any= true;
  editContractorContactStateIndex: number;
  documentTypes :any= [];
  editMode:any = false;
  uploadedFiles: FileDoc[] = [];
  editContractorCode: string;
  editContractorData: any;
  gender: string[];
  masterItemDataSubscription: Subscription;
  alertOption: { title: string; type: any; html: string; };
  dialogerror: any;
  datePickerPickerMode: string;
  datePickerPlaceHolder: string;
  private onDestroy: Subject<any>;
  showMainContent1 = true;
  showMainContent = false;
  company: any;
  shortCode: any;
  email: any;
  pANNo: any;
  mobileNo: any;
  globalSettings:any;
 // sharedDataService: any;
 private statesCache: any = null;
 private districtsPromise: Promise<any> | null = null;
 private citiesPromise: Promise<any> | null = null;
 private posPromise: Promise<any> | null = null;
 public isContractor = false;
 public allowedFileTypes:any='';
 public maxSizeAllowed:any='';
 stateFList=[];
 isDocumentStepTouched = false;
 private lastCheckedCompany: string = '';
 private lastCheckedShortCode: string = '';
 private lastCheckedEPF: string = '';
 private lastCheckedGST: string = '';
 private lastCheckedCompanyReg: string = '';
 private lastCheckedESIC: string = '';
  constructor(
    private contractorsService: ContractorsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fileUploadService: FileUploadService,
    public sharedService: SharedService,
    public sharedDataService: SharedDataService,
    private logHelperService: LogHelperService,
  )
  // {
    //   this.gender = [
      //     'male',
      //     'female',
      //     'transGender'
      //   ];
      // };
      // tslint:disable-next-line: brace-style
      {
    this.onDestroy = new Subject();
    this.datePickerPlaceHolder = this.sharedService.datePickerSettings.placeHolder;
    this.datePickerPickerMode = this.sharedService.datePickerSettings.pickerMode;
  }

  async ngOnInit() {
    const roles = JSON.parse(localStorage.getItem('Role'));
    this.isContractor = roles.some(item => item.Role_Code ===119);
    
    // Clear uploaded files at component initialization
    this.uploadedFiles = [];
    
    this.sharedService.globalMasterSettingData().subscribe((res: any) => {
      if (res) {
        this.globalSettings = res.Data.Table;
        this.maxSizeAllowed = Number(this.globalSettings.find(item => item.Code === 'DOCSIZECON1').Value)* 1024;
        this.allowedFileTypes = this.globalSettings.find(item => item.Code === 'DOCFORMATCON1').Value;
      }
    });
    this.formChangesSubscription = this.contractorForm.form.valueChanges.subscribe((form) => {
      if (form['DocumentType_Code'] === '') {
        form['DocumentType_Code'] = null;
      }
      if (form['PersonTypeMasterList_Code']
        && form['FullName']
        && form['Designation']
        && form['personemail']
        && form['contactPermobileno']) {
        this.disableAddContactPerson = false;
      } else {
        this.disableAddContactPerson = true;
      }

      if (form['epfcode1']
        && form['statecode']) {
        this.disableAddContactState = false;
      } else {
        this.disableAddContactState = true;
      }
    });

    this.showMainContent = true;
    this.showMainContent1 = false;
    // await this.contractorsService.getContractorCode().subscribe((contractorCode: any) => {
    //   this.contractorCode = contractorCode;
    // });
    // await this.contractorsService.getECPolicies().subscribe((ecPolicies: any) => this.ecPolicies = ecPolicies);
    this.sharedDataService.masterItemData$.subscribe((masterList: any) => {
      if( masterList && masterList.Data && masterList.Data.Table) {
        this.masterItemList = masterList.Data.Table;
      this.entityTypes = this.masterItemList.filter(list => list.Parent_Code === Master.EntityTypes);
      this.statusOfIndustries = this.masterItemList.filter(list => list.Parent_Code === 104);
      this.addressTypes = this.masterItemList.filter(list => list.Parent_Code === 138);
      this.contactPerTypes = this.masterItemList.filter(list => list.Parent_Code === 212);
      this.bankNames = this.masterItemList.filter(list => list.Parent_Code === 145);
      this.accountTypes = this.masterItemList.filter(list => list.Parent_Code === 213);
      this.drivingLicenceTypes = this.masterItemList.filter(list => list.Parent_Code === 194);
      this.contractorTypes = this.masterItemList.filter(list => list.Parent_Code === 215);

      }
    });

    await this.contractorsService.getCountries().subscribe((res:any) => {
      this.countries = res;
      this.lcountries = res;
    });

    // await this.contractorsService.getComplienceInfoCode().subscribe((complienceInfoCode: number) => {
    //   this.complienceInfoCode = complienceInfoCode;
    // });
    const res = {
      'Page_Code': 190,
      'RequireType': 1,
      'ActionType': 0,
      "SelectedField":"Name,DocumentType_Code,page_code,IsMandatory,IsAuthorized,IsBeforeApproval,UpdatedBy_RoleCode",
      'Search': null,
      'UserId': GLOBAL.USER_ID
    }
    // await this.contractorsService.getDocumentTypesPageModuleWise(res).subscribe((res:any) => {
    //   this.documentTypes = res;
    // });

    await this.contractorsService.getDocumentTypesPageModuleWiseV1(res).subscribe((res:any) => {
      this.documentTypes = res;
    this.fillCheckList();
    this.fillWizardSteps();

    });




   // await this.getStatesByCountryId();
    this.editContractorCode = this.activatedRoute.snapshot.paramMap.get('id');
    if (this.editContractorCode) {
      console.log('Edit mode detected, contractor code:', this.editContractorCode);
      this.editMode = true;
      this.showMainContent1 = true;
      this.showMainContent = false;
      // tslint:disable-next-line: max-line-length
      console.log('Making API call to get contractor by ID...');
      await this.contractorsService.getContractorByID(this.editContractorCode, JSON.parse(localStorage.getItem('Role'))[0].Role_Code).subscribe(async (response:any) => {
        console.log('API response received:', response);
        const contractor = response.Data;
        if (!contractor) {
          console.log('No contractor data found in response');
          return;
        }
        console.log('Contractor data found, processing...');
        this.editContractorData = contractor;

        // Check if form controls are available
        if (!this.contractorForm || !this.contractorForm.controls) {
          console.log('Form controls not ready, waiting...');
          setTimeout(() => {
            this.processContractorData(contractor);
          }, 100);
          return;
        }

        this.processContractorData(contractor);
       // this.editMode = false;
      });
      // await this.contractorsService.getContractorContactDataByID(this.editContractorCode).subscribe((res: []) => {
      //
      //   this.ContractorContactPersonViews = res;
      // });
     // this.editMode = false;
    } else {
      this.editMode = false;
    }
  }

  async processContractorData(contractor: any) {
        // Validate form controls are available
        if (!this.contractorForm || !this.contractorForm.controls) {
          console.log('Form controls not available, retrying...');
          setTimeout(() => {
            this.processContractorData(contractor);
          }, 200);
          return;
        }

        console.log('=== PROCESSING CONTRACTOR DATA ===');
        console.log('Form controls available:', Object.keys(this.contractorForm.controls).length);

        try {
          // Step 1 - Contractor Vendor
          this.headerTitleName = contractor.Company;
          this.safeSetValue('Company', contractor.Company);
          this.lastCheckedCompany = contractor.Company || '';
          this.safeSetValue('ShortCode', contractor.ShortCode);
          this.lastCheckedShortCode = contractor.ShortCode || '';
          this.safeSetValue('EmailID', contractor.EmailID);
          this.safeSetValue('PANNo', contractor.PANNo);
          this.safeSetValue('PANRegDate', contractor.PANRegDate);
          this.safeSetValue('PhoneNo', contractor.PhoneNo);
          this.safeSetValue('EffectiveDate', contractor.EffectiveDate);
          this.safeSetValue('ContractorTypeMasterList_Code', contractor.ContractorTypeMasterList_Code);
          this.safeSetValue('EntityTypeMasterList_Code', contractor.EntityTypeMasterList_Code);
          this.safeSetValue('StatusofIndustryMasterList_Code', contractor.StatusofIndustryMasterList_Code);
          this.safeSetValue('CommencementDate', contractor.CommencementDate);
          this.safeSetValue('WebSiteURL', contractor.WebSiteURL);
          
          // Register Office
          this.safeSetValue('PermentAddress1', contractor.PermentAddress1);
          this.safeSetValue('PermentAddress2', contractor.PermentAddress2);
          this.safeSetValue('PermentAddress3', contractor.PermentAddress3);
          this.safeSetValue('PermentZipCode', contractor.PermentZipCode);
          this.safeSetValue('PermentCountry_Code', contractor.PermentCountry_Code);
          await this.getStatesByCountryId();
          this.safeSetValue('PermentState_Code', contractor.PermentState_Code);
          this.getDistrictsByState();
          this.safeSetValue('PermentDistrict_Code', contractor.PermentDistrict_Code);
          this.getCitiesByDistrict();
          this.safeSetValue('PermentCity_Code', contractor.PermentCity_Code);
          this.getPOsByCity();
          this.safeSetValue('PermentPostoffice_Code', contractor.PermentPostoffice_Code);
          
          // Other Office
          this.safeSetValue('AddressTypeMasterList_Code', contractor.AddressTypeMasterList_Code);
          this.safeSetValue('LocalAddress1', contractor.LocalAddress1);
          this.safeSetValue('LocalAddress2', contractor.LocalAddress2);
          this.safeSetValue('LocalAddress3', contractor.LocalAddress3);
          this.safeSetValue('LocalZipCode', contractor.LocalZipCode);
          this.safeSetValue('LocalCountry_Code', contractor.LocalCountry_Code);
          if (contractor.LocalCountry_Code) {
            await this.getStatesByCountryIdLocal();
          }
          this.safeSetValue('LocalState_Code', contractor.LocalState_Code);
          if (contractor.LocalState_Code) {
            await this.getDistrictsByStateLocal();
          }
          this.safeSetValue('LocalDistrict_Code', contractor.LocalDistrict_Code);
          if (contractor.LocalDistrict_Code) {
            await this.getCitiesByDistrictLocal();
          }
          this.safeSetValue('LocalCity_Code', contractor.LocalCity_Code);
          if (contractor.LocalCity_Code) {
            await this.getPOsByCityLocal();
          }
          this.safeSetValue('LocalPostoffice_Code', contractor.LocalPostoffice_Code);
          
          // Step 3 - Identity details
          this.safeSetValue('adhaarnumber', contractor.AadhaarNo);
          this.safeSetValue('adhaarname', contractor.AadhaarName);
          this.safeSetValue('pannumber', contractor.PANNumber);
          this.safeSetValue('panname', contractor.PANName);
          this.safeSetValue('driliceType', contractor.DLCTypeMasterList_Code);
          this.safeSetValue('drilicenumber', contractor.DrivingLicenseNo);
          this.safeSetValue('liceanceRegDate', contractor.DrivingLicenseRegDate);
          this.safeSetValue('drilicevaliditydate', contractor.DrivingLicenseValidityDate);
          this.safeSetValue('drilicensename', contractor.DrivingLicenseName);
          this.safeSetValue('licbatchnumber', contractor.DrivingLicenseBatchNo);
          this.safeSetValue('passportno', contractor.PassportNo);
          this.safeSetValue('passportname', contractor.PassportName);
          this.safeSetValue('passportexpiredate', contractor.PassportValidityDate);
          
          // Bank details
          this.safeSetValue('bankname', contractor.BankNameMasterList_Code);
          this.safeSetValue('accounttype', contractor.AccountTypeMasterList_Code);
          this.safeSetValue('branchcode', contractor.BranchCode);
          this.safeSetValue('nameinbank', contractor.NameInBank);
          this.safeSetValue('accountnumber', contractor.BankAccountNumber);
          this.safeSetValue('branchname', contractor.BranchName);
          this.safeSetValue('ifsccode', contractor.IFSCCode);
          this.safeSetValue('micrcode', contractor.MICRCode);

          // Step 4 - Compliance
          if (contractor.EntityComplianceInfos) {
            const pfDetail = contractor.EntityComplianceInfos.find(res => res.Legislation_Code === 103);
            const gstDetail = contractor.EntityComplianceInfos.find(res => res.Legislation_Code === 100);
            const esiDetail = contractor.EntityComplianceInfos.filter(res => res.Legislation_Code === 107);

            if (pfDetail && pfDetail.RegistrationNumber && pfDetail.Other3 && pfDetail.DueOn) {
              this.safeSetValue('theemployees', true);
              this.safeSetValue('epfcode', pfDetail.RegistrationNumber);
              this.safeSetValue('epcregional', pfDetail.Other3);
              this.safeSetValue('renewaldate', pfDetail.DueOn);
            }
            if (gstDetail && gstDetail.Other1 && gstDetail.Other2) {
              this.safeSetValue('gstdetail', true);
              this.safeSetValue('gstregistrationno', gstDetail.Other1);
              this.safeSetValue('companyregistrationno', gstDetail.Other2);
            }
            esiDetail.forEach((element, index) => {
              const contractorContactState = {
                RegistrationNumber: element.RegistrationNumber,
                StateName: ''
              };
              if (this.states && this.states.length > 0) {
                this.states.forEach((state) => {
                  if (state.State_Code === element.State_Code) {
                    contractorContactState['StateName'] = state.StateName;
                    contractorContactState['State_Code'] = state.State_Code;
                  }
                });
              }
              this.contractorContactStates.push(contractorContactState);
            });
            if (this.contractorContactStates.length) {
              this.safeSetValue('employeesstates', true);
            }
            this.uniqueState(this.states, this.contractorContactStates);
          }
          
          console.log('Compliance processing completed');
          
          // Contact Person
          if (contractor.ContractorContactPersonViews && contractor.ContractorContactPersonViews.length > 0) {
            const element = contractor.ContractorContactPersonViews[0];
            this.safeSetValue('PersonTypeMasterList_Code', element.PersonTypeMasterList_Code);
            this.safeSetValue('FullName', element.FullName);
            this.safeSetValue('Designation', element.Designation);
            this.safeSetValue('personemail', element.EmailID);
            this.safeSetValue('altPersonemail11', element.AltEmailID);
            this.safeSetValue('contactPerphoneno', element.PhoneNo);
            this.safeSetValue('contactPermobileno', element.MobileNo);
            this.safeSetValue('ALtcontactPermobileno', element.AltMobileNo);
            
            contractor.ContractorContactPersonViews.forEach((element, index) => {
              const contractorContactPerson = {
                FullName: element.FullName,
                MobileNo: element.MobileNo,
                EmailID: element.EmailID,
                Designation: element.Designation,
                PhoneNo: element.PhoneNo,
                AltEmailID: element.AltEmailID,
                PersonTypeMasterList_Code: element.PersonTypeMasterList_Code,
                Name: ''
              };
              this.contactPerTypes.forEach((contractorType) => {
                if (contractorType.MasterItem_Code === element.PersonTypeMasterList_Code) {
                  contractorContactPerson['Name'] = contractorType.Name;
                }
              });
              this.ContractorContactPersonViews.push(contractorContactPerson);
            });
          }
          
          // Document binding
          if (contractor.DocumentImageMasterViews && contractor.DocumentImageMasterViews.length > 0) {
            this.uploadedFiles = [];
            contractor.DocumentImageMasterViews.forEach((file, index) => {
              this.uploadedFiles.push({
                ID: file.ID,
                file: {
                  lastModified: file.ModifiedDate,
                  name: file.UploadFileName
                },
                documentTypeCode: file.DocumentTypeMasterList_Code,
                isUploaded: true,
                VerifyBy: file.VerifyBy,
                IsVerify: file.IsVerify === null ? false : true,
                url: GLOBAL.BASE_URL_DOC + file.ParentRootFolder
              });
            });
            this.uploadedFiles = [...this.uploadedFiles];
          } else {
            this.uploadedFiles = [];
          }
          
          console.log('Contractor data processing completed successfully');
        } catch (error) {
          console.error('Error processing contractor data:', error);
        }
  }

  private safeSetValue(controlName: string, value: any): void {
    if (this.contractorForm && this.contractorForm.controls && this.contractorForm.controls[controlName]) {
      this.contractorForm.controls[controlName].setValue(value);
    } else {
      console.warn('Form control not found:', controlName);
    }
  }

  private fillCheckList(): void {
    console.log('All documentTypes from API:', this.documentTypes);
    const mandatoryDocs = this.documentTypes.filter(doc => doc.IsMandatory === true);
    console.log('Filtered mandatory documents:', mandatoryDocs);
    
    this.checkList = [
      {
        id: 1,
        text: 'Contractor Registration Checklist',
        open: true,
        childrens: [
          {
            text: 'Company Name and Code is required',
            title: 'NameandCode',
            desc: 'Company Name and Code is required.',
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return (this.contractorForm.controls.Company.valid && this.contractorForm.controls.ShortCode.valid) &&
                  (this.contractorForm.controls['Company'].value && this.contractorForm.controls['Company'].value.length &&
                    this.contractorForm.controls['ShortCode'].value && this.contractorForm.controls['ShortCode'].value.length);
              }
              return false;
            },
            hasError: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return ((this.contractorForm.controls.Company.dirty || this.contractorForm.controls.Company.touched)
                    && this.contractorForm.controls.Company.invalid)
                  || ((this.contractorForm.controls.ShortCode.dirty || this.contractorForm.controls.ShortCode.touched)
                    && this.contractorForm.controls.ShortCode.invalid);
              }
              return false;
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Email Id',
            title: 'Company Email Id',
            desc: 'Please provide valid Email Id.',
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.EmailID.valid;
              }
              return false;
            },
            hasError: () => {
             if (Object.keys(this.contractorForm.controls).length) {
               return ((this.contractorForm.controls.EmailID.dirty || this.contractorForm.controls.EmailID.touched)
                 && this.contractorForm.controls.EmailID.invalid);
             }
             return false;
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Company PAN',
            title: 'Company Pan',
            desc: 'Please provide valid PAN No.',
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.PANNo.valid;
              }
              return false;
            },
            hasError: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return ((this.contractorForm.controls.PANNo.dirty || this.contractorForm.controls.PANNo.touched)
                  && this.contractorForm.controls.PANNo.invalid);
              }
              return false;
            },
            isMandatory: true,
            isVisible: true,
            step: '1',
          },
          {
            text: 'Mobile Number',
            title: 'Mobile',
            desc: 'Please provide 10 digit Mobile number.',
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.PhoneNo.valid;
              }
              return false;
            },
            hasError: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return ((this.contractorForm.controls.PhoneNo.dirty || this.contractorForm.controls.PhoneNo.touched)
                  && this.contractorForm.controls.PhoneNo.invalid);
              }
              return false;
            },
            isMandatory: false,
            isVisible: true,
            step: '1',
          }
        ],
      },
      {
        id: 2,
        text: 'Compliance Registration Checklist',
        open: true,
        childrens: [
          {
            text: 'PF Detail',
            title: 'PF Detail',
            desc: 'Provide EPF Code, EPC Regional Office And Date.',
            step: '4',
            isVisible: true,
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.theemployees.value === true
                  && this.contractorForm.controls.epfcode.valid
                  && this.contractorForm.controls.epcregional.valid
                  && this.contractorForm.controls.renewaldate.valid;
              }
              return false;
            },
            hasError: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.theemployees.value === true
                  && ((this.contractorForm.controls.epfcode.invalid)
                    || (this.contractorForm.controls.epcregional.invalid)
                    || (this.contractorForm.controls.renewaldate.invalid));
              }
              return false;
            },
          },
          {
            text: 'GST Detail',
            title: 'GST Detail',
            desc: 'Provide GST Registraton Number, Company Registration Number.',
            step: '4',
            isVisible: true,
            isValid: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.gstdetail.value === true
                  && this.contractorForm.controls.gstregistrationno.valid
                  && this.contractorForm.controls.companyregistrationno.valid;
              }
              return false
            },
            hasError: () => {
              if (Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.gstdetail.value === true
                  && ((this.contractorForm.controls.gstregistrationno.invalid)
                    || (this.contractorForm.controls.companyregistrationno.invalid));
              }
              return false
            },
          },
          {
            text: 'ESI Detail',
            title: 'ESI Detail',
            desc: 'Provide ESIC Code, ESIC Local Office And Date.',
            step: '4',
            isVisible: true,
            isValid: () => {
              return this.contractorContactStates.length > 0;
            },
            hasError: () => {
              if(Object.keys(this.contractorForm.controls).length) {
                return this.contractorForm.controls.employeesstates.value === true
                  && this.contractorContactStates.length === 0;
              }
              return false;
            },
          }
        ],
      },
      {
        id: 3,
        text: 'Document Checklist',
        open: true,
        childrens: this.documentTypes
          .filter(doc => doc.IsMandatory === true)
          .map(doc => {
            return {
              text: doc.Name,
              title: doc.Name,
              desc: `Mandatory document: ${doc.Name}`,
              isValid: () => {
                const isUploaded = this.uploadedFiles.some(file => file.documentTypeCode === doc.DocumentType_Code);
                return isUploaded;
              },
              hasError: () => {
                const isUploaded = this.uploadedFiles.some(file => file.documentTypeCode === doc.DocumentType_Code);
                return this.isDocumentStepTouched && !isUploaded;
              },
              isMandatory: true,
              isVisible: true,
              step: '5',
            };
          })
      }
      
    ];
  }

  private fillWizardSteps(): void {
    this.wizardSteps = [
      {
        id: 'contractor',
        name: 'Contractor',
        isValid: () => {
          if (Object.keys(this.contractorForm.controls).length) {
            return (this.contractorForm.controls.Company.valid
              && this.contractorForm.controls.ShortCode.valid &&
              ((this.contractorForm.controls['Company'].value &&  this.contractorForm.controls['Company'].value.length)
                && (this.contractorForm.controls['ShortCode'].value && this.contractorForm.controls['ShortCode'].value.length))
              && this.contractorForm.controls.EmailID.valid
              && this.contractorForm.controls.PANNo.valid
              && this.contractorForm.controls.PhoneNo.valid);
          }
          return false;
        },
      },
      {
        id: 'contactPerson',
        name: 'Contact Person',
        isValid: () => {
          return true;
        },
      },
      {
        id: 'identityDetail',
        name: 'Identity Detail',
        isValid: () => { return true; },

      },
      {
        id: 'complianceDetail',
        name: 'Compliance Detail',
        isValid: () => {
          let valid = true;
          if (this.contractorForm.controls.theemployees.value === true) {
            if (this.contractorForm.controls.epfcode.valid
              && this.contractorForm.controls.epcregional.valid
              && this.contractorForm.controls.renewaldate.valid) {
              valid = true;
            } else {
              valid = false;
            }
          }

          if (this.contractorForm.controls.employeesstates.value === true) {
            if (this.contractorContactStates.length === 0) {
              valid = false;
            }
          }
          return valid;
        }
      },
      {
        id: 'documentDetail',
        name: 'Document Detail',
        isValid: () => { return true; }
      }
    ];
  }

  ngAfterViewInit(): void {
    this.contractorForm.reset();
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.

  }

  checkAvailabilityForEmail() {
  }

  getStatesByCountryId() {
    return new Promise((resolve, reject) => {
      if (this.statesCache) {
        // If data is already cached, use it
        this.states = this.statesCache;
        resolve(0);
      } else {
        // If not cached, make the API call
        this.contractorsService.getStatesByCountryId(this.contractorForm.value.PermentCountry_Code || 100)
          .subscribe(
            (response: any) => {
              this.statesCache = response; // Cache the response
              this.states = response;
              resolve(0);
            },
            error => {
              reject(error);
            }
          );
      }
    });
  }

  getStatesByCountryIdLocal() {
    return new Promise((resolve, reject) => {
      const countryCode = this.contractorForm.value.LocalCountry_Code || 100;
      this.contractorsService.getStatesByCountryId(countryCode)
        .subscribe(
          (response: any) => {
            this.statesLocal = response;
            resolve(0);
          },
          error => {
            reject(error);
          }
        );
    });
  }
  // getStatesByCountryId() {
  //   return  new Promise((resolve, reject) => {
  //     this.contractorsService.getStatesByCountryId(this.contractorForm.control.value['PermentCountry_Code'] || 100)
  //       .subscribe((response: any) => {
  //         this.states = response;
  //         resolve(0);
  //       },
  //         error => {
  //           reject();
  //         });
  //   });
  // }
  // getStatesByCountryIdLocal() {
  //   this.contractorsService.getStatesByCountryId(this.contractorForm.value.PermentCountry_Code).subscribe((response:any) => {
  //     this.statesLocal = response;
  //   });
  // }


  fetchDistricts(stateCode: string): Promise<any> {
    if (!this.districtsPromise) {
      // Create a new API call if not already ongoing
      this.districtsPromise = new Promise((resolve, reject) => {
        this.contractorsService.getDistrictsByState(stateCode).subscribe(
          (response: any) => {
            this.districtsPromise = null; // Clear the promise after resolving
            resolve(response);
          },
          (error: any) => {
            this.districtsPromise = null; // Clear the promise after rejecting
            reject(error);
          }
        );
      });
    }
    return this.districtsPromise; // Return the ongoing or resolved promise
  }
  

  getDistrictsByState() {
    const stateCode = this.contractorForm.control.value['PermentState_Code'];
    this.fetchDistricts(stateCode).then((response: any) => {
      this.districts = response; // Set the data for Permanent State
    });
  }
  
  getDistrictsByStateLocal() {
    return new Promise((resolve, reject) => {
      const stateCode = this.contractorForm.value['LocalState_Code'];
      if (!stateCode) {
        resolve(0);
        return;
      }
      this.contractorsService.getDistrictsByState(stateCode).subscribe(
        (response: any) => {
          this.districtsLocal = response;
          resolve(0);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  // getDistrictsByState() {
  //   this.contractorsService.getDistrictsByState(this.contractorForm.control.value['PermentState_Code']).subscribe((response:any) => {
  //     this.districts = response;
  //   });
  // }

   // getDistrictsByStateLocal() {
  //   this.contractorsService.getDistrictsByState(this.contractorForm.value['LocalState_Code']).subscribe((response:any) => {
  //     this.districtsLocal = response;
  //   });
  // }


  fetchCities(districtCode: string): Promise<any> {
    if (!this.citiesPromise) {
      // Create a new API call if not already ongoing
      this.citiesPromise = new Promise((resolve, reject) => {
        this.contractorsService.getCitiesByDistrict(districtCode).subscribe(
          (response: any) => {
            this.citiesPromise = null; // Clear the promise after resolving
            resolve(response);
          },
          (error: any) => {
            this.citiesPromise = null; // Clear the promise after rejecting
            reject(error);
          }
        );
      });
    }
    return this.citiesPromise; // Return the ongoing or resolved promise
  }

  getCitiesByDistrict() {
    const districtCode = this.contractorForm.control.value['PermentDistrict_Code'];
    this.fetchCities(districtCode).then((response: any) => {
      this.cities = response; // Set the data for Permanent District
    });
  }
  
  getCitiesByDistrictLocal() {
    return new Promise((resolve, reject) => {
      const districtCode = this.contractorForm.value['LocalDistrict_Code'];
      if (!districtCode) {
        resolve(0);
        return;
      }
      this.contractorsService.getCitiesByDistrict(districtCode).subscribe(
        (response: any) => {
          this.citiesLocal = response;
          resolve(0);
        },
        error => {
          reject(error);
        }
      );
    });
  }


  // getCitiesByDistrict() {
  //   this.contractorsService.getCitiesByDistrict(this.contractorForm.control.value['PermentDistrict_Code']).subscribe((response:any) => {
  //     this.cities = response;
  //   });
  // }
  // getCitiesByDistrictLocal() {
  //   this.contractorsService.getCitiesByDistrict(this.contractorForm.control.value['LocalDistrict_Code']).subscribe((response:any) => {
  //     this.citiesLocal = response;
  //   });
  // }


  fetchPOs(cityCode: string): Promise<any> {
    if (!this.posPromise) {
      // Create a new API call if not already ongoing
      this.posPromise = new Promise((resolve, reject) => {
        this.contractorsService.getPOsByCity(cityCode).subscribe(
          (response: any) => {
            this.posPromise = null; // Clear the promise after resolving
            resolve(response);
          },
          (error: any) => {
            this.posPromise = null; // Clear the promise after rejecting
            reject(error);
          }
        );
      });
    }
    return this.posPromise; // Return the ongoing or resolved promise
  }

  getPOsByCity() {
    const cityCode = this.contractorForm.control.value['PermentCity_Code'];
    this.fetchPOs(cityCode).then((response: any) => {
      this.postOfficies = response; // Set the data for Permanent City
    });
  }
  
  getPOsByCityLocal() {
    return new Promise((resolve, reject) => {
      const cityCode = this.contractorForm.value['LocalCity_Code'];
      if (!cityCode) {
        resolve(0);
        return;
      }
      this.contractorsService.getPOsByCity(cityCode).subscribe(
        (response: any) => {
          this.postOfficiesLocal = response;
          resolve(0);
        },
        error => {
          reject(error);
        }
      );
    });
  }


  // getPOsByCity() {
  //   this.contractorsService.getPOsByCity(this.contractorForm.control.value['PermentCity_Code']).subscribe((response:any) => {
  //     this.postOfficies = response;
  //   });
  // }

  // getPOsByCityLocal() {
  //   this.contractorsService.getPOsByCity(this.contractorForm.control.value['LocalCity_Code']).subscribe((response:any) => {
  //     this.postOfficiesLocal = response;
  //   });
  // }

  addContractorContactPerson(index?: number) {
    const contractorContactPerson = {
      AltEmailID: this.contractorForm.control.value['altPersonemail11'],
      AltMobileNo: this.contractorForm.control.value['ALtcontactPermobileno'],
      ContractorVendor_Code: this.complienceInfoCode,
      Designation: this.contractorForm.control.value['Designation'],
      EmailID: this.contractorForm.control.value['personemail'],
      FullName: this.contractorForm.control.value['FullName'],
      MobileNo: this.contractorForm.control.value['contactPermobileno'],
      PersonTypeMasterList_Code: this.contractorForm.control.value['PersonTypeMasterList_Code'],
      PhoneNo: this.contractorForm.control.value['contactPerphoneno']
    };

    this.contractorForm.controls['altPersonemail11'].reset();
    this.contractorForm.controls['ALtcontactPermobileno'].reset();
    this.contractorForm.controls['Designation'].reset();
    this.contractorForm.controls['personemail'].reset();
    this.contractorForm.controls['FullName'].reset();
    this.contractorForm.controls['contactPermobileno'].reset();
    this.contractorForm.controls['PersonTypeMasterList_Code'].reset();
    this.contractorForm.controls['contactPerphoneno'].reset();
    if (typeof index !== 'undefined') {
      this.ContractorContactPersonViews[index] = contractorContactPerson;
    } else {
      this.ContractorContactPersonViews.push(contractorContactPerson);
    }
  }

  updateContractorContactPerson() {
    this.addContractorContactPerson(this.editContractorContactPersonIndex);
    this.hideUpdateContactPerson = true;
  }

  editContractorContactPerson(person, index) {
    this.editContractorContactPersonIndex = index;
    this.contractorForm.controls['altPersonemail11'].setValue(person.AltEmailID);
    this.contractorForm.controls['ALtcontactPermobileno'].setValue(person.AltMobileNo);
    this.contractorForm.controls['Designation'].setValue(person.Designation);
    this.contractorForm.controls['personemail'].setValue(person.EmailID);
    this.contractorForm.controls['FullName'].setValue(person.FullName);
    this.contractorForm.controls['contactPermobileno'].setValue(person.MobileNo);
    this.contractorForm.controls['PersonTypeMasterList_Code'].setValue(person.PersonTypeMasterList_Code);
    this.contractorForm.controls['contactPerphoneno'].setValue(person.PhoneNo);
    this.hideUpdateContactPerson = false;
  }

  deleteContractorContactPerson(index: number) {
    this.ContractorContactPersonViews.splice(index, 1);
  }

  uniqueState(list,selected){
    const d = selected.map((obj) => {return obj.State_Code;});
    this.stateFList=list.filter((obj) => d.indexOf(obj.State_Code) === -1);
  }

  addContractorContactState(index?: number) {
    const contractorContactState = {
      State_Code: this.contractorForm.control.value['statecode'],
      RegistrationNumber: this.contractorForm.control.value['epfcode1'],
      StateName: ''
    };
    this.states.forEach((state) => {
      if (state.State_Code === this.contractorForm.control.value['statecode']) {
        contractorContactState['StateName'] = state.StateName;
      }
    });
    this.contractorForm.controls['statecode'].reset();
    this.contractorForm.controls['epfcode1'].reset();
    if (typeof index !== 'undefined') {
      this.contractorContactStates[index] = contractorContactState;
    } else {
      this.contractorContactStates.push(contractorContactState);
    }
    this.uniqueState(this.states,this.contractorContactStates);
  }

  updateContractorContactState() {
    this.addContractorContactState(this.editContractorContactStateIndex);
    this.hideUpdateContactState = true;
  }

  editContractorContactState(state, index) {
    this.editContractorContactStateIndex = index;
    this.contractorForm.controls['statecode'].setValue(state.State_Code);
    this.contractorForm.controls['epfcode1'].setValue(state.RegistrationNumber);
    this.hideUpdateContactState = false;
  }

  deleteContractorContactState(index: number) {
    this.contractorContactStates.splice(index, 1);
    this.uniqueState(this.states,this.contractorContactStates);
  }
  clearFormDetail(ind, data) {
    if (data === false) {
      if (ind === 0) {
        this.contractorForm.controls['epfcode'].setValue(null);
        this.contractorForm.controls['epcregional'].setValue(null);
        this.contractorForm.controls['renewaldate'].setValue(null);
      } else if (ind === 1) {
        this.contractorForm.controls['gstregistrationno'].setValue(null);
        this.contractorForm.controls['companyregistrationno'].setValue(null);
      }
    }
  }

  onSubmit(formData, redirect = true) {
    const isApproval  = this.globalSettings.find(item => item.Code === 'MOD152PG195CONAPVV01').Value;
    const contractor: any = {
      ContractorVendor_Code: this.editContractorCode,
      EntityTypeMasterList_Code: formData.EntityTypeMasterList_Code,
      StatusofIndustryMasterList_Code: formData.StatusofIndustryMasterList_Code,
      Company: this.contractorForm.controls['Company'].value,
      CommencementDate: formData.CommencementDate,
      ShortCode: this.contractorForm.controls['ShortCode'].value,
      EmailID: formData.EmailID,
      PhoneNo: formData.PhoneNo,
      PANNo: formData.PANNo,
      PANRegDate: formData.PANRegDate,
      EffectiveDate: formData.EffectiveDate,
      WebSiteURL: formData.WebSiteURL,
      AddressTypeMasterList_Code: formData.AddressTypeMasterList_Code,
      PermentAddress1: formData.PermentAddress1,
      PermentAddress2: formData.PermentAddress2,
      PermentAddress3: formData.PermentAddress3,
      PermentZipCode: formData.PermentZipCode,
      PermentCountry_Code: formData.PermentCountry_Code,
      PermentState_Code: formData.PermentState_Code,
      PermentCity_Code: formData.PermentCity_Code,
      PermentDistrict_Code: formData.PermentDistrict_Code,
      PermentPostoffice_Code: formData.PermentPostoffice_Code,
      LocalAddress1: formData.LocalAddress1,
      LocalAddress2: formData.LocalAddress2,
      LocalAddress3: formData.LocalAddress3,
      LocalZipCode: formData.LocalZipCode,
      LocalCountry_Code: formData.LocalCountry_Code,
      LocalState_Code: formData.LocalState_Code,
      LocalDistrict_Code: formData.LocalDistrict_Code,
      LocalCity_Code: formData.LocalCity_Code,
      LocalPostoffice_Code: formData.LocalPostoffice_Code,
      BankNameMasterList_Code: formData.bankname,
      NameInBank: formData.nameinbank,
      BranchName: formData.branchname,
      BankAccountNumber: formData.accountnumber,
      BranchCode: formData.branchcode,
      AccountTypeMasterList_Code: formData.accounttype,
      IFSCCode: formData.ifsccode,
      MICRCode: formData.micrcode,
      PANNumber: formData.pannumber,
      PANName: formData.panname,
      AadhaarNo: formData.adhaarnumber,
      AadhaarName: formData.adhaarname,
      DLCTypeMasterList_Code: formData.driliceType,
      DrivingLicenseNo: formData.drilicenumber,
      DrivingLicenseValidityDate: formData.drilicevaliditydate,
      DrivingLicenseName: formData.drilicensename,
      DrivingLicenseBatchNo: formData.licbatchnumber,
      DrivingLicenseRegDate: formData.liceanceRegDate,
      PassportNo: formData.passportno,
      PassportName: formData.passportname,
      PassportValidityDate: formData.passportexpiredate,
      CreateBy: GLOBAL.USER_ID,
      RoleCode: JSON.parse(localStorage.getItem('Role'))[0].Role_Code,
      ContractorTypeMasterList_Code: formData.ContractorTypeMasterList_Code,
      EntityComplianceInfos: [],
      ContractorContactPersonViews: [],
      DocumentImageMasterViews: [],
      isApproval:isApproval==='1'?'0':'1'
    };

    if (formData.theemployees === true) {
      const entityComplianceInfo: any = {};
      entityComplianceInfo.ShortCode = 'CCLRA1003';
      entityComplianceInfo.ContractorVendor_Code = this.editContractorCode;
      entityComplianceInfo.RegistrationNumber = formData.epfcode;
      entityComplianceInfo.Other3 = formData.epcregional;
      entityComplianceInfo.DueOn = formData.renewaldate;
      entityComplianceInfo.Legislation_Code = 103;
      contractor.EntityComplianceInfos.push(entityComplianceInfo);
    }
    if (formData.gstdetail === true) {
      const entityComplianceInfo: any = {};
      entityComplianceInfo.ShortCode = 'CCLRA1004';
      entityComplianceInfo.Other1 = formData.gstregistrationno;
      entityComplianceInfo.Other2 = formData.companyregistrationno;
      entityComplianceInfo.Legislation_Code = 100;
      contractor.EntityComplianceInfos.push(entityComplianceInfo);
    }
    if (formData.employeesstates === true) {
      this.contractorContactStates.forEach((entityrel, index) => {
        const entityComplianceInfo: any = {};
        entityComplianceInfo.ShortCode = 'CCLRA1007';
        entityComplianceInfo.State_Code = entityrel.State_Code;
        entityComplianceInfo.RegistrationNumber = entityrel.RegistrationNumber;
        entityComplianceInfo.Legislation_Code = 107;
        contractor.EntityComplianceInfos.push(entityComplianceInfo);
      });
    }
    if (this.ContractorContactPersonViews.length) {
      contractor.ContractorContactPersonViews = this.ContractorContactPersonViews;
    }
    if (this.uploadedFiles.length) {
      this.uploadedFiles.forEach((file) => {
        if (file.isUploaded) {
          contractor.DocumentImageMasterViews.push({
            ID: file.ID,
            DocumentTypeMasterList_Code: file.documentTypeCode
          });
        } else {
          contractor.DocumentImageMasterViews.push({
            DocumentTypeMasterList_Code: file.documentTypeCode
          });
        }
      });
    }

    const uploadParams = {
      contractorvendor_code: ''
    };
    if (this.editMode) {
      this.contractorsService.updateContractor(contractor).subscribe((result: any) => {
        uploadParams.contractorvendor_code = result.Data || this.editContractorCode;
        
        // Upload files if there are any
        const filesToUpload = this.uploadedFiles.filter(file => !file.isUploaded);
        if (filesToUpload.length > 0) {
          this.fileUploadService.uploadFiles(filesToUpload, uploadParams, GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_DOC)
            .subscribe((res) => {
              this.logHelperService.logSuccess({
                message: 'Contractor Updated successfully'
              });
              if (redirect) {
                this.router.navigate(['contractor/contractors']);
              } else {
                this.contractorForm.reset();
                this.clearForm();
              }
            });
        } else {
          this.logHelperService.logSuccess({
            message: 'Contractor Updated successfully'
          });
          if (redirect) {
            this.router.navigate(['contractor/contractors']);
          } else {
            this.contractorForm.reset();
            this.clearForm();
          }
        }
      });
    } else {
      this.contractorsService.addContractor(contractor).subscribe((result: any) => {
        uploadParams.contractorvendor_code = result;
        if (uploadParams.contractorvendor_code) {
          this.fileUploadService.uploadFiles(this.uploadedFiles, uploadParams, GLOBAL.APIS.CONTRACTOR_MANAGEMENT.UPLOAD_DOC)
            .subscribe((res) => {
              if (redirect) {
                this.router.navigate(['contractor/contractors']);
              } else {
                this.contractorForm.reset();
                this.clearForm();
              }
            });
        }
        this.logHelperService.logSuccess({
          message: 'Sub-Contractor addded successfully'
        });
        this.contractorForm.reset();
        this.clearForm();
      });
    }
  }
  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    // this.formChangesSubscription.unsubscribe();
    // this.masterItemDataSubscription.unsubscribe();
  }

  onFilesChanged(newFiles) {
    console.log('onFilesChanged called with:', newFiles);
    this.uploadedFiles = newFiles;
    this.isDocumentStepTouched = true;
    // Update checklist validation
    this.fillCheckList();
    console.log('uploadedFiles updated to:', this.uploadedFiles);
  }

  onCancel() {
    this.router.navigate(['contractor/contractors']);
  }

  saveAndNew() {
    this.onSubmit(this.contractorForm.value, false);

    this.router.navigate(['contractor/create-sub-contractor']);
    this.clearForm();
  }
  updateAndNew() {
    this.onSubmit(this.contractorForm.value, false);
  }

  updateOnly() {
    this.onSubmit(this.contractorForm.value, true);
  }
  // tslint:disable-next-line: function-name
  save() {
    this.onSubmit(this.contractorForm.value, false);

    this.router.navigate(['contractor/contractors']);
    this.clearForm();
  }

  clearForm() {
    this.ContractorContactPersonViews = [];
    this.contractorContactStates = [];
    this.uploadedFiles = [];
    this.lastCheckedCompany = '';
    this.lastCheckedShortCode = '';
    this.lastCheckedEPF = '';
    this.lastCheckedGST = '';
    this.lastCheckedCompanyReg = '';
    this.lastCheckedESIC = '';
  }
  // tslint:disable-next-line: function-name
  CheckCompany() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const companyControl = this.contractorForm.controls['Company'];
    const currentCompany = companyControl.value;

    // Don't call API if field is empty or value hasn't changed
    if (!currentCompany || currentCompany.trim() === '' || currentCompany === this.lastCheckedCompany) {
      return true;
    }

    // Update the last checked value
    this.lastCheckedCompany = currentCompany;

    this.contractorsService
      .checkCompany(currentCompany, this.editContractorCode)
      .subscribe((res: any) => {
        this.company = res.Data;

        if (this.company > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Firm / Company name has already been used. Please enter a different input.'
          });

          companyControl.reset();
          this.lastCheckedCompany = ''; // Reset since we cleared the field
        }
      });

    return true;
  }
  // tslint:disable-next-line: function-name
  CheckShort() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const shortCodeControl = this.contractorForm.controls['ShortCode'];
    const currentShortCode = shortCodeControl.value;

    // Don't call API if field is empty or value hasn't changed
    if (!currentShortCode || currentShortCode.trim() === '' || currentShortCode === this.lastCheckedShortCode) {
      return true;
    }

    // Update the last checked value
    this.lastCheckedShortCode = currentShortCode;

    this.contractorsService
      .checkShortCode(currentShortCode, this.editContractorCode)
      .subscribe((res: any) => {
        this.shortCode = res.Data;

        if (this.shortCode > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Vendor code has already been used with other Firm / Company. Please enter a different vendor code.'
          });

          shortCodeControl.reset();
          this.lastCheckedShortCode = ''; // Reset since we cleared the field
        }
      });

    return true;
  }
  // tslint:disable-next-line: function-name
  CheckEmail() {
  const emailControl = this.contractorForm.controls['EmailID'];

  // 🔴 Case 1: Email entered but format is INVALID
  if (emailControl && emailControl.value && emailControl.invalid) {
    this.logHelperService.logError({
      message: 'Please enter a valid email address.'
    });

    emailControl.reset();
    return true;
  }

  // 🔵 Case 2: Email is valid → check duplicate
  if (!emailControl || !emailControl.value || emailControl.invalid) {
    return true;
  }

  this.contractorsService
    .checkEmail(emailControl.value, this.editContractorCode)
    .subscribe((res: any) => {
      this.email = res.Data;

      if (this.email > 0) {
        this.logHelperService.logError({
          message:
            'Email address already taken for another company. Please use a different email id for this company.'
        });

        emailControl.reset();
      }
    });

  return true;
}
  // tslint:disable-next-line: function-name
  CheckPanCardNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const panControl = this.contractorForm.controls['PANNo'];

    // 🔴 Do NOT call API if empty
    if (
      !panControl ||
      !panControl.value ||
      panControl.value.toString().trim() === ''
    ) {
      return true;
    }

    // 🔴 Do NOT call API if PAN format is invalid
    if (panControl.invalid) {
      return true;
    }

    // ✅ Call API only when PAN is valid
    this.contractorsService
      .checkPanCard(panControl.value, this.editContractorCode)
      .subscribe((res: any) => {
        this.pANNo = res.Data;

        if (this.pANNo > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This PAN number has been used for another Firm / Company. Please enter a different input.'
          });

          panControl.reset();
        }
      });

    return true;
  }
  checkAlternateEmailID() {
    // safety checks
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const primaryCtrl = this.contractorForm.controls['personemail'];
    const altCtrl = this.contractorForm.controls['altPersonemail11'];

    // Do nothing if controls or values are missing
    if (
      !primaryCtrl ||
      !altCtrl ||
      !primaryCtrl.value ||
      !altCtrl.value
    ) {
      return true;
    }

    const primaryEmail = primaryCtrl.value.toString().trim();
    const altEmail = altCtrl.value.toString().trim();

    // Compare only when both have values
    if (
      primaryEmail !== '' &&
      altEmail !== '' &&
      primaryEmail === altEmail
    ) {
      this.logHelperService.logError({
        message: 'Email ID and Alternate email ID should not be the same.'
      });

      altCtrl.reset();
    }

    return true;
  }
  // checkAlternateMobileNo() {
  //   if ( this.contractorForm.controls.contactPermobileno.value != null && 
  //     this.contractorForm.controls.ALtcontactPermobileno.value != null &&
  //     (this.contractorForm.controls.contactPermobileno.value === this.contractorForm.controls.ALtcontactPermobileno.value)) {
  //     {
  //       this.logHelperService.logError({
  //         // tslint:disable-next-line: max-line-length
  //         message: 'Mobile No and Alternate mobile no should not be same input.'
  //       });
  //       this.contractorForm.controls['ALtcontactPermobileno'].reset();
  //     }
  //   }
  //   return true;
  // }
  checkAlternateMobileNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const mobileCtrl = this.contractorForm.controls['contactPermobileno'];
    const altMobileCtrl = this.contractorForm.controls['ALtcontactPermobileno'];

    if (!mobileCtrl || !altMobileCtrl) {
      return true;
    }

    const mobile = mobileCtrl.value;
    const altMobile = altMobileCtrl.value;

    // run only if BOTH have values
    if (
      mobile &&
      altMobile &&
      mobile.toString().trim() !== '' &&
      altMobile.toString().trim() !== '' &&
      mobile === altMobile
    ) {
      this.logHelperService.logError({
        message: 'Mobile No and Alternate Mobile No should not be the same.'
      });

      altMobileCtrl.reset();
      return false;
    }

    return true;
  }
  checkMobileNo() {
    if (!this.contractorForm || !this.contractorForm.controls) {
      return true;
    }

    const mobileCtrl = this.contractorForm.controls['contactPermobileno'];

    // ❌ Do nothing if empty
    if (
      !mobileCtrl ||
      !mobileCtrl.value ||
      mobileCtrl.value.toString().trim() === ''
    ) {
      return true;
    }

    // ✅ FIRST: compare with alternate mobile (if exists)
    this.checkAlternateMobileNo();

    // ✅ SECOND: call uniqueness API
    this.contractorsService
      .checkMobileNO(mobileCtrl.value, this.editContractorCode)
      .subscribe((res: any) => {
        this.mobileNo = res.Data;

        if (this.mobileNo > 0) {
          this.logHelperService.logError({
            message:
              'This field requires a unique entry. This Mobile No has been used for another Firm / Company. Please enter a different input.'
          });

          mobileCtrl.reset();
        }
      });

    return true;
  }
  duplicatefieldvalidation(evt, fieldName, code){
    if(!evt || evt.trim() === ''){
      return;
    }

    // Check which field and prevent duplicate calls
    if(code === 103 && evt === this.lastCheckedEPF) return;
    if(code === 100 && evt === this.lastCheckedGST) return;
    if(code === 0 && evt === this.lastCheckedCompanyReg) return;
    if(code === 107 && evt === this.lastCheckedESIC) return;

    // Update last checked value
    if(code === 103) this.lastCheckedEPF = evt;
    if(code === 100) this.lastCheckedGST = evt;
    if(code === 0) this.lastCheckedCompanyReg = evt;
    if(code === 107) this.lastCheckedESIC = evt;

    const req = {
      "Contractor_Code": this.editContractorCode,
      "Legislation_Code": code,
      "RegistrationNo": evt,
      "RequireType":0,
      "ActionType": 0,
      "UserID": GLOBAL.USER_ID
    }
    this.contractorsService.complianceDetailValidation(req).subscribe((res:any) => {
      if(res.Data > 0){
        this.logHelperService.logError({
          message: 'This field requires a unique entry. This '+fieldName+' has already been used. Please enter different input.'
        });
      }
    });
  }
}
